export default __webpack_public_path__ + "static/1023-16374b5b0cdc98896a88127c282e2397.gif";